import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

import Input from '@superfunnel/ui-core/Input';

interface GallerySearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

export const GallerySearchInput = ({
  value,
  onChange,
  placeholder,
}: GallerySearchInputProps) => (
  <Input
    icon={<MagnifyingGlassIcon className="size-4.5" />}
    placeholder={placeholder}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    variant="search"
    wrapperClassName="w-full [&>div]:rounded-2lg lg:w-60 lg:shrink-0"
    className="rounded-2lg bg-card [&_input]:font-normal [&_input]:tracking-normal [&_input]:placeholder:text-base-500"
  />
);
